import { WrapperDivObt, WrapperUploadImgObtEdition } from './styles'
import FileObtInput from '../FileObtInput'
import Alert from '../Alert'
import ModalCropper from '../ModalCropper'
import messages from '../../../constants/messages'
import { useDispatch } from 'react-redux'
import { useState, useEffect, useCallback } from 'react'
import { getRatioValue } from '../../../herpers/cropperHelper'
import NotificationModal from '../NotificationModal'
import { campaignIdStringFormat } from '../../../herpers/completeCampingId'

async function dataURLtoFile(dataUrl, filename) {
  const arr = dataUrl.split(',');
  if (arr.length < 2) {
    console.error('Invalid data URL');
    return null;
  }
  const mimeMatch = arr[0].match(/:(.*?);/);
  if (!mimeMatch) {
    console.error('Could not parse MIME type from data URL');
    return null;
  }
  const mime = mimeMatch[1];
  const bstr = atob(arr[arr.length - 1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while(n--){
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, {type:mime});
}

const DivUploadObt = ({
    dimensions: { width, height },
    advertisingId,
    croppedImageUrl,
    handleImage,
    imageUrl,
    label,
    displayN,
    isObt,
    isMobile,
    maxWeight,
    unitMaxWeight,
    campaignId
}) => {
    const dispatch = useDispatch()
    const [isOpen, setIsOpen] = useState(false)
    const [loading, setLoading] = useState(false)
    const [imageForCropper, setImageForCropper] = useState()
    const [aspectRatio, setAspectRatio] = useState()
    const [validationError, setValidationError] = useState('')
    const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
    const [errorModalTitle, setErrorModalTitle] = useState('Notificaciones');
    const [errorModalMessageText, setErrorModalMessageText] = useState('');
    const [originalSelectedFile, setOriginalSelectedFile] = useState(null);
    const [image, setImage] = useState();
    const [errorFormat, setErrorFormat] = useState(false)

    useEffect(() => {
        if (width && height) {
         
            const ratio = getRatioValue(width, height)
            setAspectRatio(width / ratio / (height / ratio))
        }
    }, [width, height])

    const handleCloseCropper = () => {
        setIsOpen(false)
        setLoading(false)
        setImageForCropper(undefined)
    }

    let isValidFormat = false;
    const validateFileFormat = (fileType) => {
        isValidFormat = false;
        switch (fileType) {
            case 'image/png':
            case 'image/jpg':
            case 'image/jpeg':
                isValidFormat = true;
                setErrorModalMessageText('');
                break;
            default:
                isValidFormat = false;
                setErrorModalMessageText(messages.messageErrorInvalidFormat);
                setIsErrorModalOpen(true);
                setLoading(false);
                break;
        }
    };
    

    let isValidWeight = false;
    const validateFileWeight = (fileSize) => {
        isValidWeight = false;
        if (!maxWeight || !unitMaxWeight) {
            isValidWeight = true;
            setErrorModalMessageText('');
            return;
        }
        const fileSizeKB = Math.round(fileSize / 1000);
        const fileSizeMB = (fileSize / 1000 / 1000).toFixed(2);
        let MError = messages.messageErrorExceededWeight;

        switch (unitMaxWeight) {
            case 'B':
                if (fileSize < maxWeight) isValidWeight = true;
                break;
            case 'KB':
                if (fileSizeKB < maxWeight) isValidWeight = true;
                break;
            case 'MB':
                if (fileSizeMB < maxWeight) isValidWeight = true;
                break;
            default:
                isValidWeight = false;
                MError = 'Invalid unit for max weight.';
                break;
        }
        if (!isValidWeight) {
            setErrorModalMessageText(MError);
            setIsErrorModalOpen(true);
            setLoading(false);
        }
    };

   

   


    const showAllowedFormatText = !croppedImageUrl && !validationError && label;
    const showSuccessMessage = (croppedImageUrl || imageUrl) && !validationError && !isOpen;
    const fileInputId = `file-obt-input-${advertisingId}`;

    const handleImg = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setValidationError('');
        setLoading(true);
        setOriginalSelectedFile(file);
        e.target.value = '';

        validateFileFormat(file.type);
        if (!isValidFormat) {
            setLoading(false);
            setOriginalSelectedFile(null);
            return;
        }

        validateFileWeight(file.size);
        if (!isValidWeight) {
            setLoading(false);
            setOriginalSelectedFile(null);
            return;
        }

        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            imageSetHandler(reader.result);
        };
        reader.onerror = () => {
            setLoading(false);
            setErrorModalMessageText(messages.messageErrorGeneral);
            setIsErrorModalOpen(true);
            setOriginalSelectedFile(null);
        };
    }

    const imageSetHandler = (dispatchState) => {
        setImage(dispatchState)
        setIsOpen(true)
        setErrorFormat(false)
      }
    

      const imageLoaded = useCallback(async(croppedImageDataUrl) => {
        if (croppedImageDataUrl) {
            const fileName = originalSelectedFile ? originalSelectedFile.name : 'cropped_image.png';
            const croppedFile = await dataURLtoFile(croppedImageDataUrl, fileName);
            handleImage(croppedFile, '', true)
        }
      }, [handleImage, originalSelectedFile])
    return (
        <WrapperDivObt >
            <WrapperUploadImgObtEdition state={validationError ? 'error' : 'success'} displayN={displayN} >
                <FileObtInput
                    state={validationError ? 'error' : 'success'}
                    onChange={handleImg}
                    id={fileInputId}
                    isObt={isObt}
                    isMobile={isMobile}
                    uploadLabel="Cargar imagen" />
                {showAllowedFormatText && label}
                {showSuccessMessage && (
                    <Alert title={messages.messageSuccess} state="success" />
                )}

                {isOpen && (
                    <ModalCropper
                        isOpen={isOpen}
                        onClose={handleCloseCropper}
                        image={image}
                        isObt={true}
                        width={width}
                        height={height}
                        aspectRatio={aspectRatio}
                        imageLoaded={imageLoaded}
                    />
                )}
            </WrapperUploadImgObtEdition>
            <NotificationModal
                isOpen={isErrorModalOpen}
                onClose={() => setIsErrorModalOpen(false)}
                campaignId={campaignIdStringFormat( campaignId)}
                title={errorModalTitle}
            />
        </WrapperDivObt>
    )
}
export default DivUploadObt;